import { Input, InputComponentProps } from 'formik-semantic-ui';

export const InputWithoutEnter = (props: InputComponentProps) => (
  <Input
    {...props}
    inputProps={{
      ...props.inputProps,
      input: {
        onKeyPress: (e: any) => e.which === 13 && e.preventDefault(),
      },
    }}
  />
);
